import { FetchErrorType } from '../../../types/common/fetch-error-type';
import { FetchResultType } from '../../../types/common/fetch-result';
import { defaultErrorResponseConverter } from './fetch/error-response-converter-generator';
import { fetchJsonWithTokenCheck } from './fetch/fetch-json-with-token-check';
import { mapFetchResult } from './fetch/map-fetch-result';
import {
  RawDetailErrorType,
  RawNonFieldErrorsType
} from './fetch/types/common-error-type';
import { HttpMethod } from './fetch/types/enum/http-method';

/* made to avoid syntax highlight error */
type ResultType<S> = FetchResultType<S, FetchErrorType<void>>;

export const getTemplateFn = async <
  RawSuccessResponseType extends object,
  SuccessResponseType
>(
  token: string,
  uri: string,
  successResponseConverter: (v: RawSuccessResponseType) => SuccessResponseType
): Promise<ResultType<SuccessResponseType>> => {
  const result = await fetchJsonWithTokenCheck({
    token,
    uri,
    method: 'GET'
  });

  return mapFetchResult(
    result as FetchResultType<
      RawSuccessResponseType,
      RawDetailErrorType | RawNonFieldErrorsType
    >,
    successResponseConverter,
    defaultErrorResponseConverter
  );
};

const noop = () => ({});

export const deleteTempleteFn = async (
  token: string,
  uri: string
): Promise<ResultType<{}>> => {
  const result = await fetchJsonWithTokenCheck({
    token,
    uri,
    method: 'DELETE'
  });

  return mapFetchResult(
    result as FetchResultType<{}, RawDetailErrorType | RawNonFieldErrorsType>,
    noop,
    defaultErrorResponseConverter
  );
};

export const fetchWithoutBodyTemplateFn2 = (
  httpMethod: ('GET' | 'DELETE') & HttpMethod
) => (httpMethod === 'GET' ? getTemplateFn : deleteTempleteFn);
